/** App store links per identity app, keyed by the app's name. */
export type InstallLinks = { android?: string; apple?: string };

export const installLinksMap: Record<string, InstallLinks> = {
  Yivi: {
    android:
      'https://play.google.com/store/apps/details?id=org.irmacard.cardemu',
    apple: 'https://apps.apple.com/app/yivi/id1294092994',
  },
  Datakeeper: {
    android: 'https://play.google.com/store/apps/details?id=nl.rabobank.ida',
    apple: 'https://apps.apple.com/app/datakeeper/id1546059184',
  },
  Digidentity: {
    android: 'https://play.google.com/store/apps/details?id=com.digidentity',
    apple: 'https://apps.apple.com/app/digidentity-wallet/id916749732',
  },
  Truid: {
    android: 'https://play.google.com/store/apps/details?id=me.veritru',
    apple: 'https://apps.apple.com/app/truid/id1610295519',
  },
  Yoti: {
    android:
      'https://play.google.com/store/apps/details?id=com.yoti.mobile.android.live',
    apple: 'https://apps.apple.com/app/yoti-your-digital-identity/id983980808',
  },
  Nect: {
    android: 'https://play.google.com/store/apps/details?id=com.nect.app.prod',
    apple: 'https://apps.apple.com/app/nect-wallet/id1331065474',
  },
  'ReadID Ready': {
    android: 'https://play.google.com/store/apps/details?id=com.readid.ready',
    apple: 'https://apps.apple.com/app/readid-ready/id1486164875',
  },
  Lissi: {
    android:
      'https://play.google.com/store/apps/details?id=io.lissi.mobile.android&hl=nl',
    apple: 'https://apps.apple.com/nl/app/lissi-id-wallet/id6475958390',
  },
};
